import {JRNIAppModel} from "../core/jrni_app";

class AdminJRNIAppModel extends JRNIAppModel {

    constructor(data) {

        super(data);

    }


    setupScripts(){
        if (this._data && this._data.script_packs){
          this._data.script_packs.forEach( (pack) => {
            pack.scripts.forEach( (script) => {
              if (script.type == "AdminScript" && !this[script.name]){
                this[script.name] = function (data) {
                    return this.$callScriptFunction(script, data);
                };

              }
            })
          });
        } 
        // noe setup any public scripts 
        super.setupScripts()    
    }

    ///////////////////////////////
    // redis cache commands

    // run a single cache command
    cache(name, key){
      const args = Array.prototype.slice.call(arguments, 2);

      return this.$post('cache', {name}, {key: key, args: args})
    }

    // run a single cache command and run a push
    cachePush(name, key){
      const args = Array.prototype.slice.call(arguments, 2);

      return this.$post('cache', {name}, {key: key, args: args, push: true})
    }

    // run a single cache command and do a public push
    cachePublicPush(name, key){
      const args = Array.prototype.slice.call(arguments, 2);

      return this.$post('cache', {name}, {key: key, args: args, push: true, public: true})
    }

    // run a series of commands and return them as named keys!
    async cacheMulti(commands){

      const result = await this.$post('cache', {name: "multiple"}, {commands});

      return results;
    }
  
    ////////////////////////////////////
    // consoldated versions - supports the push option in a single command using more variable params

    // run a single caache command
    async cacheCmd(command, key) {
        let args = Array.prototype.slice.call(arguments, this.cacheCmd.length);
        const lastArg = args[args.length - 1];
        let push = false;
        if (typeof lastArg === 'object' && lastArg !== null && lastArg.push) {
            push = true
            args = args.slice(0, -1);
        }
        let response
        if (push) {
            response = await this.cachePush(command, key, ...args);
        } else {
            response = await this.cache(command, key, ...args);
        }
        return [response.result, response.time];
    }

    // run a series of commands and return them as an array
    async cacheMultiCmds(commands) {
        const payload = commands.map((command) => {
            const last = command[command.length - 1];
            let push = false;
            if (typeof last === 'object' && last !== null && last.push) {
                push = true
                command = command.slice(0, -1);
            }
            return {
                name: command[0],
                key: command[1],
                args: command.slice(2),
                push
            };
        });
        const results = await this.cacheMulti(payload);
        return results;
    }


}

export {
    AdminJRNIAppModel
}